// @ts-nocheck
import { IRoute } from '@umijs/core';
import { AnyAction } from 'redux';
import React from 'react';
import { EffectsCommandMap, SubscriptionAPI } from 'dva';
import { match } from 'react-router-dom';
import { Location, LocationState, History } from 'history';

export * from '/var/www/chunsing-app-ui/src/models/finance/file';
export * from '/var/www/chunsing-app-ui/src/models/finance/note';
export * from '/var/www/chunsing-app-ui/src/models/wms/file';
export * from '/var/www/chunsing-app-ui/src/models/wms/note';
export * from '/var/www/chunsing-app-ui/src/pages/admin-shipment/delivery-booking/model';
export * from '/var/www/chunsing-app-ui/src/pages/delivery-booking/model';
export * from '/var/www/chunsing-app-ui/src/pages/delivery-note/model';
export * from '/var/www/chunsing-app-ui/src/pages/inbound/model';
export * from '/var/www/chunsing-app-ui/src/pages/inventory-batch-adjustment/model';
export * from '/var/www/chunsing-app-ui/src/pages/label-manage/model';
export * from '/var/www/chunsing-app-ui/src/pages/outbound-console/model';
export * from '/var/www/chunsing-app-ui/src/pages/product-manage/products/model';
export * from '/var/www/chunsing-app-ui/src/pages/product-manage/suppliers/model';
export * from '/var/www/chunsing-app-ui/src/pages/rma-order/model';
export * from '/var/www/chunsing-app-ui/src/pages/stocktake/model';
export * from '/var/www/chunsing-app-ui/src/pages/warehouse-bill/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/admin/bill-manage/warehouse-bill/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/amr-replenishment/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/bin-lock-setting/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/inbound/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/inventory/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/outbound/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/products/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/rma-order/model';
export * from '/var/www/chunsing-app-ui/src/pages/wms/transfer-pick-order/model';

export interface Action<T = any> {
  type: T
}

export type Reducer<S = any, A extends Action = AnyAction> = (
  state: S | undefined,
  action: A
) => S;

export type ImmerReducer<S = any, A extends Action = AnyAction> = (
  state: S,
  action: A
) => void;

export type Effect = (
  action: AnyAction,
  effects: EffectsCommandMap,
) => void;

/**
 * @type P: Type of payload
 * @type C: Type of callback
 */
export type Dispatch<P = any, C = (payload: P) => void> = (action: {
  type: string;
  payload?: P;
  callback?: C;
  [key: string]: any;
}) => any;

export type Subscription = (api: SubscriptionAPI, done: Function) => void | Function;

export interface Loading {
  global: boolean;
  effects: { [key: string]: boolean | undefined };
  models: {
    [key: string]: any;
  };
}

/**
 * @type P: Params matched in dynamic routing
 */
export interface ConnectProps<
  P extends { [K in keyof P]?: string } = {},
  S = LocationState,
  T = {}
> {
  dispatch?: Dispatch;
  // https://github.com/umijs/umi/pull/2194
  match?: match<P>;
  location: Location<S> & { query: T };
  history: History;
  route: IRoute;
}

export type RequiredConnectProps<
  P extends { [K in keyof P]?: string } = {},
  S = LocationState,
  T = {}
  > = Required<ConnectProps<P, S, T>>

/**
 * @type T: React props
 * @type U: match props types
 */
export type ConnectRC<
  T = {},
  U = {},
  S = {},
  Q = {}
> = React.ForwardRefRenderFunction<any, T & RequiredConnectProps<U, S, Q>>;

